<ion-header>
  <ion-toolbar class="gradient-primary-right">
    <ion-buttons slot="start">
      <ion-menu-button>
        <ion-icon class="icon-menu" color="dark" name="menu"></ion-icon>
        <app-inbox-count></app-inbox-count>
      </ion-menu-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'MENU.home' | translate }}
    </ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="goAccountDetailPage()">
        <ion-icon class="font-18" color="dark" name="ellipsis-vertical-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar class="gradient-primary-right ion-no-padding" *ngIf="ready">
    <app-news-card-slide class="full-width" [newsCardSlideType]="'account_home'" [setReady]="ready"></app-news-card-slide>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding-bottom" color="light" #content>
  <ion-refresher class="background-light" slot="fixed" (ionRefresh)="doRefresh($event)">
    <ion-refresher-content class="background-light"
      pullingIcon="chevron-down-circle-outline"
      pullingText=""
      refreshingSpinner="circles"
      refreshingText="">
    </ion-refresher-content>
  </ion-refresher>
  <div class="content-div">
    <div class="info-div full-width ion-padding">
      <div class="full-width ion-padding-horizontal ion-text-center" (click)="presentTitlePrompt()">
        <div class="text-ellipsis font-20" style="justify-content: center;align-items: center;">
          <ng-container *ngIf="accountInfo?.title?.value">
            {{ accountInfo.title.value }}
          </ng-container>
          <ng-container *ngIf="!accountInfo?.title?.value">
            <ng-container *ngIf="accountInfo?.coupleList.length === 2 && accountInfo?.coupleList[0]?.name && accountInfo?.coupleList[1]?.name else titleBlock">
              {{ 'ACCOUNT.auto_title' | translate: { couple1: accountInfo.coupleList[0].name, couple2: accountInfo.coupleList[1].name } }}
            </ng-container>
            <ng-template #titleBlock>
              {{ 'ACCOUNT.lbl.wedding_title' | translate }}
            </ng-template>
          </ng-container>
        </div>
      </div>
  
      <ng-container *ngIf="days || hours || minutes">
        <app-count-down class="ion-margin-bottom" [days]="days" [hours]="hours" [minutes]="minutes" [msg]="replaceEventType('ACCOUNT.lbl.countdown' | translate)" [setReady]="ready" *ngIf="ready"></app-count-down>
      </ng-container>
      
  
      <!-- <ion-grid class="full-width ion-margin-bottom" *ngIf="days || hours || minutes" fixed>
        <ion-row>
          <ion-col class="ion-text-center" size="4">
            <ion-label class="font-10" color="medium">{{ 'LBL.days' | translate }}</ion-label>
          </ion-col>
          <ion-col class="ion-text-center" size="1">
          </ion-col>
          <ion-col class="ion-text-center" size="3">
            <ion-label class="font-10" color="medium">{{ 'LBL.hours' | translate }}</ion-label>
          </ion-col>
          <ion-col class="ion-text-center" size="1">
          </ion-col>
          <ion-col class="ion-text-center" size="3">
            <ion-label class="font-10" color="medium">{{ 'LBL.minutes' | translate }}</ion-label>
          </ion-col>
        </ion-row>
        <ion-row class="countdown-row">
          <ion-col class="ion-text-center" size="4">
            <div><ion-text class="font-34 font-bold" color="dark">{{ days ? days : 0 }}</ion-text></div>
          </ion-col>
          <ion-col class="ion-text-center" size="1">
            <div class="flick"><ion-text class="font-34 font-bold" color="dark">:</ion-text></div>
          </ion-col>
          <ion-col class="ion-text-center" size="3">
            <div><ion-text class="font-34 font-bold" color="dark">{{ hours ? hours : 0 }}</ion-text></div>
          </ion-col>
          <ion-col class="ion-text-center" size="1">
            <div class="flick"><ion-text class="font-34 font-bold" color="dark">:</ion-text></div>
          </ion-col>
          <ion-col class="ion-text-center" size="3">
            <div><ion-text class="font-34 font-bold" color="dark">{{ minutes ? minutes : 0 }}</ion-text></div>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-text-center">
            <ion-text class="font-12 font-med ion-text-uppercase countdown-text" color="dark">{{ replaceEventType('ACCOUNT.lbl.countdown' | translate) }}</ion-text>
          </ion-col>
        </ion-row>
      </ion-grid> -->
    
      <ng-container *ngIf="newWebsiteMode">
        <ion-card class="gallery slide-gallery full-width-height background-transparent ion-text-center ion-no-padding ion-no-margin" (click)="selectPhoto()" button>
          <ng-container *ngIf="websiteCover?.url">
            <app-cached-image [type]="'account-home-cover'" [src]="websiteCover.url" [spinner]="true" *ngIf="websiteCover.type !== 'local'"></app-cached-image>
            <ion-img class="cover-gallery full-width-height" [src]="websiteCover.url" *ngIf="websiteCover.type === 'local'"></ion-img>
          </ng-container>
          <ion-img class="gallery full-width-height" *ngIf="!websiteCover?.url" src="./assets/wedding/img/background/home/gallery1.svg"></ion-img>
        </ion-card>
      </ng-container>
      <ng-container *ngIf="!newWebsiteMode">
        <swiper-container  autoplay-delay="3000" autoplay-disable-on-interaction="false" centered-slides="true" *ngIf="accountInfo?.gallery?.length">
          <swiper-slide *ngFor="let gallery of accountInfo.gallery; let i = index">
            <ion-card class="gallery slide-gallery full-width-height background-transparent ion-text-center ion-no-padding ion-no-margin" (click)="selectPhoto()" button>
              <app-cached-image [type]="'account-home'" [src]="gallery" [spinner]="true" *ngIf="gallery"></app-cached-image>
            </ion-card>
          </swiper-slide>
        </swiper-container>
        <ion-card class="slide-gallery background-transparent ion-text-center ion-no-padding ion-no-margin" (click)="selectPhoto()" *ngIf="!accountInfo?.gallery?.length">
          <ion-img class="gallery full-width-height" src="./assets/wedding/img/background/home/gallery1.svg"></ion-img>
        </ion-card>
      </ng-container>
    </div>
  
    <div class="full-width" *ngIf="ready">
      <swiper-container [slidesPerView]="slidePerView" style="padding: 6px 11px;">
        <swiper-slide *ngIf="totalChecklistCount">
          <ion-card class="ion-no-margin dashboard-card" (click)="goAccountTaskPage()" [color]="'white'" button>
            <ion-item class="dashboard-item ion-item-no-padding background-transparent" [style.margin]="'5px auto'" lines="none">
              <ion-label class="ion-no-margin ion-text-center">
                <div>
                  <ion-icon class="icon-small" color="primary" src="./assets/wedding/icon/menu/accountTask.svg"></ion-icon>
                </div>
                <div>
                  <ion-label class="font-10 font-med ion-text-wrap ion-no-margin" color="dark">{{ 'CHECKLIST.completed.title' | translate }}</ion-label>
                </div>
                <div class="font-20">
                  <div><ion-text class="font-bold">{{ completedChecklistCount }}</ion-text></div>
                  <div class="font-normal font-10 ion-text-right">{{ 'LBL.of_total' | translate: { total: totalChecklistCount } }}</div>
                </div>
              </ion-label>
            </ion-item>
          </ion-card>
        </swiper-slide>
        <swiper-slide *ngIf="currentPrivilege?.['guest']?.['view']">
          <app-guest-statistic-item class="full-width" [reset]="reset" [status]="{ attending: 'attending' }" [setAttendingType]="'attending'" [module]="'guest'" [name]="'LIST.attending_status.attending_guest' | translate" [statisticType]="'attending'" [all]="true" [cardType]="'dashboard'" [showNumber]="true" [showTotal]="true" [whiteBackground]="true"></app-guest-statistic-item>
        </swiper-slide>
        <swiper-slide *ngIf="currentPrivilege?.['checkin']?.['view']">
          <app-guest-statistic-item class="full-width" [reset]="reset" [status]="{ checkin: true }" [setCheckinType]="'attended'" [module]="'checkin'" [cardType]="'dashboard'" [statisticType]="'checkin'" [all]="true" [showNumber]="true" [showTotal]="true" [whiteBackground]="true" [name]="'LIST.checkin.attended_guest' | translate"></app-guest-statistic-item>
        </swiper-slide>
        <swiper-slide *ngIf="currentPrivilege?.['gift']?.['view']">
          <app-gift-statistic-item class="full-width" [reset]="reset" [all]="true" [showNumber]="true" [showTotal]="false" [cardType]="'dashboard'" [statisticType]="'recorded'" [module]="'gift'" [name]="'GIFT.lbl.recorded_gift' | translate" [setGiftType]="''"[whiteBackground]="true"></app-gift-statistic-item>
        </swiper-slide>
      </swiper-container>
    
      <ion-card class="team-card ion-padding-vertical" (click)="goAccountDetailPage('accountUser')" *ngIf="currentPrivilege?.['account']?.['view']" button>
        <ion-label class="font-14 font-bold ion-margin-horizontal" color="dark">
          {{ 'ACCOUNT.lbl.team_size' | translate | uppercase }}: {{ accountUserList?.length }}
        </ion-label>
        <ion-grid class="full-width ion-text-center" *ngIf="accountUserList?.length" fixed>
          <ion-row [class]="accountUserList?.length < 4 ? 'ion-justify-content-start' : 'ion-justify-content-center'">
            <ion-col class="avatar-col" [size]="'auto'" *ngFor="let user of accountUserList">
              <ng-container *ngIf="onlineList && onlineList[user.uid] && onlineList[user.uid].online$ | async as presence">
                <ion-avatar class="small-avatar center" [ngClass]="presence?.online ? 'online-border' : 'offline-border'">
                  <ng-container *ngIf="user?.avatar?.url">
                    <ion-img [src]="user.avatar.url" *ngIf="user?.avatar?.type === 'local'"></ion-img>
                    <app-cached-image [src]="user.avatar.url" [spinner]="true" *ngIf="user?.avatar?.type !== 'local'"></app-cached-image>
                  </ng-container>
                  <ion-icon color="medium" src="./assets/wedding/img/avatar/blank.svg" *ngIf="!user?.avatar?.url"></ion-icon>
                </ion-avatar>
              </ng-container>
              
              <ion-label class="font-10">{{ user.name }}</ion-label>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card>
    </div>
  </div>
  
</ion-content>
